export default {
  subtitle:
    'We now need you to set a secure password so we can save your application and any offer you may receive.',
  paragraph: 'Set a password to save your application',
  passwordLabel: 'Create a secure password',
  tooltip:
    'Your password must be at least 12 characters, including one uppercase letter, a number, a symbol, and contain no leading or trailing whitespace',
  submitButton: 'Continue'
};
